import React from 'react';

const ProjectDetail = ({ projects, project_id, onClose }) => {
  const project = projects?.find((p) => p.ID == project_id);
  if (!project_id || !project) return null;

  return (
    <>
      <div
        className="modal fade show"
        tabIndex="-1"
        aria-labelledby="projectDetailModalLabel"
        aria-modal="true"
        role="dialog"
        style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} // dark overlay
      >
        <div className="modal-dialog modal-xl modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title text-info" id="projectDetailModalLabel">
                Project Detail
              </h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                aria-label="Close"
                onClick={onClose}
                style={{ filter: 'invert(1)' }} // make close button visible on dark header if needed
              />
            </div>

            <div className="modal-body" style={{ fontSize: '16px', lineHeight: '1.5' }}>
              <h5 className="text-info text-center mb-4">Project Profile Report</h5>

              <div className="row mb-4">
                <div className="col-md-6">
                  <p><strong>Project Title:</strong> {project.name}</p>
                  <p><strong>Start Date:</strong> {project.StartDate || 'N/A'}</p>
                  <p><strong>Purpose:</strong> {project.purpose || 'N/A'}</p>
                  <p><strong>Allocated Budget:</strong> {project.BudgetAllocated || 'N/A'}</p>
                </div>
                <div className="col-md-6">
                  <p><strong>Last Update:</strong> {project.updated_at || 'N/A'}</p>
                  <p><strong>End Date:</strong> {project.EndDate || 'N/A'}</p>
                  <p><strong>Registered Date:</strong> {project.Date || 'N/A'}</p>
                  <p><strong>Budget Spent:</strong> {project.BudgetSpent || 'N/A'}</p>
                </div>
              </div>

              <div className="mb-4">
                <p><strong>Description:</strong> {project.purpose || 'No description provided.'}</p>
              </div>

              <div className="row mb-4">
                <div className="col-md-6">
                  <h6 className="text-info mb-3">Project Locations</h6>
                  <table className="table table-bordered table-sm">
                    <thead className="table-light">
                      <tr>
                        <th>#</th>
                        <th>Region</th>
                        <th>District</th>
                        <th>Village</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(project.Region?.split(',') || []).map((_, idx) => {
                        const region = project.Region?.split(',')[idx]?.trim() || 'N/A';
                        const district = project.District?.split(',')[idx]?.trim() || 'N/A';
                        const village = project.Village?.split(',')[idx]?.trim() || 'N/A';
                        return (
                          <tr key={idx}>
                            <td>{idx + 1}</td>
                            <td>{region}</td>
                            <td>{district}</td>
                            <td>{village}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

                <div className="col-md-6">
                  <h6 className="text-info mb-3">Project Sectors</h6>
                  <table className="table table-bordered table-sm">
                    <thead className="table-light">
                      <tr>
                        <th>#</th>
                        <th>Sector</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(project.Sector?.split(',') || []).map((sector, idx) => (
                        <tr key={idx}>
                          <td>{idx + 1}</td>
                          <td>{sector.trim()}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="row mb-4">
                <div className="col-md-6">
                  <h6 className="text-info mb-3">Implementors</h6>
                  <table className="table table-bordered table-sm">
                    <thead className="table-light">
                      <tr>
                        <th>Implementor</th>
                        <th>Implementing Partner</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{project.Implementor || 'N/A'}</td>
                        <td>{project.ImplementingPartner || 'N/A'}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="col-md-6">
                  <h6 className="text-info mb-3">Funder</h6>
                  <table className="table table-bordered table-sm">
                    <thead className="table-light">
                      <tr>
                        <th>Funder</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{project.donor || 'N/A'}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-danger"
                onClick={onClose}
                style={{ minWidth: '80px' }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Backdrop */}
      <div className="modal-backdrop fade show"></div>
    </>
  );
};

export default ProjectDetail;
